import axios from "../../axios-atis";

import * as actionTypes from "./actionTypes";

export const fetchContactsBegin = () => ({
  type: actionTypes.FETCH_CONTACTS_BEGIN
});

export const fetchContactsSuccess = contacts => {
  return {
    type: actionTypes.FETCH_CONTACTS_SUCCESS,
    payload: { contacts }
  };
};

export const fetchContactsError = error => {
  return {
    type: actionTypes.FETCH_CONTACTS_FAILED,
    payload: { error }
  };
};
export const fetchContacts = (page, pageSize, filtred, sorted) => {
  return dispatch => {
    dispatch(fetchContactsBegin());
    let url = "/contacts";
    axios
      .get(url)
      .then(response => {
        dispatch(fetchContactsSuccess(response.data));
      })
      .catch(err => {
        dispatch(fetchContactsError(err));
      });
  };
};

export const fetchContactBegin = () => ({
  type: actionTypes.FETCH_CONTACT_BEGIN
});

export const fetchContactSuccess = contact => {
  return {
    type: actionTypes.FETCH_CONTACT_SUCCESS,
    payload: { contact }
  };
};

export const fetchContactError = error => {
  return {
    type: actionTypes.FETCH_CONTACT_FAILED,
    payload: { error }
  };
};
export const fetchContact = id => {
  return dispatch => {
    dispatch(fetchContactBegin());
    let url = "/contacts/" + id;
    axios
      .get(url)
      .then(response => {
        dispatch(fetchContactSuccess(response.data));
      })
      .catch(err => {
        dispatch(fetchContactError(err));
      });
  };
};

export const addContactBegin = () => {
  return {
    type: actionTypes.ADD_CONTACT_BEGIN
  };
};

export const addContactSuccess = contact => {
  return {
    type: actionTypes.ADD_CONTACT_SUCCESS,
    payload: { contact }
  };
};

export const addContactError = error => {
  return {
    type: actionTypes.ADD_CONTACT_FAILED,
    payload: { error }
  };
};
export const addContact = newContact => {
  return dispatch => {
    dispatch(addContactBegin());
    let url = "/contacts";
    axios
      .post(url, newContact)
      .then(response => {
        if (null == response.data.result) {
          dispatch(addContactError(response.data));
        } else {
          dispatch(addContactSuccess(response.data.result));
        }
      })
      .catch(err => {
        dispatch(addContactError(err));
      });
  };
};

export const updtContactBegin = () => {
  return {
    type: actionTypes.UPDATE_CONTACT_BEGIN
  };
};

export const updtContactSuccess = contact => {
  return {
    type: actionTypes.UPDATE_CONTACT_SUCCESS,
    payload: { contact }
  };
};

export const updtContactError = error => {
  return {
    type: actionTypes.UPDATE_CONTACT_FAILED,
    payload: { error }
  };
};
export const updtContact = contact => {
  return dispatch => {
    dispatch(updtContactBegin());
    let url = `/contacts/${contact.id}`;
    axios
      .post(url, contact)
      .then(response => {
        if (undefined === response || undefined === response.data) {
          dispatch(updtContactError(null));
        }
        dispatch(updtContactSuccess(response.data.result));
      })
      .catch(err => {
        dispatch(updtContactError(err));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/contact.js